export default {
    openControlMenu({commit}){
        commit('SET_OPEN_CONTROL_MENU')
    },
    toggleControlMenu({commit}){
        commit('SET_TOGGLE_CONTROL_MENU')
    },
    closeControlMenu({commit}){
        commit('SET_CLOSE_CONTROL_MENU')
    }
}